import React from "react";

// Ye ek single feature row hai
const FeatureItem = ({ icon: Icon, title, description, isLast }) => {
  return (
    <div className="group">
      <div className="flex items-start gap-2 xl:gap-4">
        {/* Icon Circle */}
        <div className="flex-shrink-0 bg-white p-2 rounded-full border border-white">
          {/* Icon ko component ki tarah use kar rahe hain */}
          <Icon className="w-6 h-6 text-[#183076]" />
        </div>

        {/* Text Content */}
        <div className="flex flex-col">
          <h3 className="text-white font-bold text-[18px] md:text-[20px] lg:text-[26px] 2xl:text-[30px] mb-1">
            {title}
          </h3>
          <p className="text-white text-[16px] md:text-[18px] 2xl:text-[24px] leading-relaxed">
            {description}
          </p>
        </div>
      </div>

      {/* Divider */}
      {!isLast && <div className="mt-8 border-b border-white w-full" />}
    </div>
  );
};

export default FeatureItem;
